const MoneyDonated = (prop) => {
  const { count, show, orientation = 'landscape' } = prop;

  const donationAmountPerEagle = 5000;
  const totalDonationAmount = new Intl.NumberFormat(
    'en-US', {
        style: 'currency', 
        currency: 'USD', 
        minimumFractionDigits: 0, 
        maximumFractionDigits: 0
    }).format(count * donationAmountPerEagle)

  return (
    <div style={{...styles.container, ...(orientation === 'portrait' ? styles.containerPortrait : {}), ...(show ? styles.show : {})}}>
      <p style={{...styles.content, ...(orientation === 'portrait' ? styles.contentPortrait : {})}}>and {totalDonationAmount}<br /> has been donated.</p>
    </div>
  );
};

const styles = {
  container: {
    color: '#ffffff',
    fontFamily: 'MorganStanley',
    fontSize: '1.8em',
    fontWeight: 'bold',
    textAlign: 'center',

    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',

    opacity: '0',
    transition: 'opacity 1s'
  },

  containerPortrait: {
    fontSize: '4.1em',
    alignItems: 'end',
    justifyContent: 'center',
  },

  content: {
    lineHeight: '1.1em',
    marginLeft: '6vw'
  },

  contentPortrait: {
    lineHeight: '1em',
    marginBottom: '6vh',
    marginLeft: '0',
    textAlign: 'center'
  },

  show: {
    opacity: '1'
  }
};

export default MoneyDonated;